module.exports = __webpack_public_path__ + "static/media/visualizacion-logo-caracol-television-2020-01@3x.cb685760.png";